<div *ngIf="viewedDocuments$ | async as documents">
	<div
		class="document-list dropdown"
		(mouseover)="documentsMouseover()"
		(mouseout)="documentsMouseout()"
	>
		<div>
			<app-input
				[(ngModel)]="searchValue"
				placeholder="Search documents"
				[startIcon]="ICON.SEARCH"
				[endIcon]="searchValue ? ICON.CLOSE : null"
				(endItemClick)="clearSearch()"
				[testHook]="testHooks.SearchValue"
			></app-input>
		</div>
		<div
			*ngIf="documents.length > 0 && searchValue?.length === 0"
			class="overflow-y-auto"
		>
			<ng-container
				*ngTemplateOutlet="
					documentTemplate;
					context: {
						documentsList: (documents | sort: ['lastViewed'] : ['desc']),
					}
				"
			></ng-container>
		</div>

		<div *ngIf="searchValue?.length > 0" class="overflow-y-auto">
			<ng-container
				*ngTemplateOutlet="
					documentTemplate;
					context: {
						documentsList:
							(documents
							| filter: ['title', 'folderName'] : '<>' : searchValue
							| sort: ['lastViewed'] : ['desc']),
					}
				"
			></ng-container>
		</div>
	</div>
</div>

<ng-template #documentTemplate let-documentsList="documentsList">
	<div class="h-80">
		<cdk-virtual-scroll-viewport
			itemSize="66"
			class="mt-3 h-full overflow-y-auto"
		>
			<div *cdkVirtualFor="let document of documentsList; trackBy: trackById">
				<div
					(click)="goToDocument(document.id)"
					class="border border-grey-lighter rounded-xl px-2 h-16 bg-grey-lightest flex flex-col justify-center mb-2 hover:bg-green-lightest hover:border-green-lighter cursor-pointer"
					[testHook]="testHooks.GoToDocumentDiv"
				>
					<div class="text-sm truncate">{{ document.title }}</div>
					<div class="flex justify-between gap-2">
						<div class="flex overflow-hidden">
							<div
								*ngIf="document.folderName"
								class="text-xs text-grey flex gap-1 truncate"
							>
								<app-icon
									[icon]="ICON.FOLDER"
									class="mr-1"
									[testHook]="testHooks.FolderIcon"
								></app-icon>
								<div class="truncate" [innerHtml]="document.folderName"></div>
							</div>
						</div>
						<div
							*ngIf="document.lastViewed > 0"
							class="flex mr-1 text-xs text-grey gap-1 whitespace-nowrap flex-nowrap"
						>
							<app-icon
								[icon]="ICON.VIEW"
								[testHook]="testHooks.ViewIcon"
							></app-icon>
							{{ document.lastViewed | timeAgo }}
						</div>
					</div>
				</div>
			</div>
		</cdk-virtual-scroll-viewport>
	</div>
</ng-template>
